module.exports = __webpack_public_path__ + "img/delete.fdd316f5.png";